module.exports = __webpack_public_path__ + "static/media/listing.dbf73152.svg";